import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Composable para detectar el estado de conexión a internet.
 * Muestra/oculta un banner cuando se pierde o recupera la conexión.
 */
export function useNetworkStatus() {
  const isOnline = ref(navigator.onLine)
  const wasOffline = ref(false) // true si se acaba de reconectar

  let reconnectTimer = null

  const handleOnline = () => {
    isOnline.value = true
    wasOffline.value = true
    // Ocultar "Reconectado" después de 3 segundos
    reconnectTimer = setTimeout(() => {
      wasOffline.value = false
    }, 3000)
  }

  const handleOffline = () => {
    isOnline.value = false
    wasOffline.value = false
  }

  onMounted(() => {
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
  })

  onUnmounted(() => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
    if (reconnectTimer) clearTimeout(reconnectTimer)
  })

  return {
    isOnline,
    wasOffline
  }
}
